<template>
  <div class="column" v-if="enabled">
    <div class="field">
      <b-radio :name="`level${level}`" :key="value" :native-value="value" @input="onInput" v-model="currentModel">
        <b>{{ title}}</b><br>
        <span v-if="subtitle" class="has-text-grey">{{ subtitle}}</span>
      </b-radio>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WsRequestExamTypeFormItem',
  props: {
    title: String,
    subtitle: String,
    value: String,
    parents: Array,
    model: Array,
    level: Number,
    items: Array
  },
  watch: {
    model: {
      immediate: true,
      deep: true,
      handler (model) {
        const value = model[this.level]
        this.currentModel = value
        if (!this.parents || !this.parents.length) {
          this.enabled = true
        } else {
          const parentLevel = this.model[this.level - 1]
          if (parentLevel) {
            this.enabled = !!this.parents.find(parent => parentLevel === parent)
          } else {
            this.enabled = false
          }
        }
      }
    }
  },
  data: function () {
    return {
      currentModel: '',
      enabled: false
    }
  },
  methods: {
    onInput (value) {
      const arr = [ ...this.model ]
      for (let i = this.level; i < this.items.length; i++) {
        arr[i] = null
      }
      arr[this.level] = value
      this.$emit('input', arr)
    }
  }
}
</script>
